// GoogleContact.jsx
import React, { useEffect, useState } from "react";

const CLIENT_ID =
  "470676783464-l79og9cvikh9vb5019o261e5h7ak8krm.apps.googleusercontent.com";
const SCOPES = "https://www.googleapis.com/auth/contacts.readonly";

const GoogleContact = () => {
  const [accessToken, setAccessToken] = useState(null);
  const [contacts, setContacts] = useState([]);
  const [error, setError] = useState("");
  const [scriptLoaded, setScriptLoaded] = useState(false);

  // Load Google Identity script on mount
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;
    script.onload = () => {
      setScriptLoaded(true);
      initGoogleLogin();
    };
    document.body.appendChild(script);
  }, []);

  // Silent login or fallback to interactive
  const initGoogleLogin = () => {
    if (!window.google || !window.google.accounts) {
      setError("❌ Google Identity Services not available.");
      return;
    }

    const tokenClient = window.google.accounts.oauth2.initTokenClient({
      client_id: CLIENT_ID,
      scope: SCOPES,
      prompt: "", // silent login
      callback: async (tokenResponse) => {
        if (tokenResponse?.access_token) {
          setAccessToken(tokenResponse.access_token);
          await fetchContacts(tokenResponse.access_token);
        } else {
          startInteractiveLogin(); // fallback
        }
      },
    });

    tokenClient.requestAccessToken();
  };

  const startInteractiveLogin = () => {
    const tokenClient = window.google.accounts.oauth2.initTokenClient({
      client_id: CLIENT_ID,
      scope: SCOPES,
      prompt: "consent", // show popup
      callback: async (tokenResponse) => {
        if (tokenResponse?.access_token) {
          setAccessToken(tokenResponse.access_token);
          await fetchContacts(tokenResponse.access_token);
        } else {
          setError("❌ Google login failed or denied.");
        }
      },
    });

    tokenClient.requestAccessToken();
  };

  const fetchContacts = async (token) => {
    try {
      const res = await fetch(
        "https://people.googleapis.com/v1/people/me/connections?pageSize=2000&personFields=names,emailAddresses,phoneNumbers",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await res.json();

      if (!data.connections || data.connections.length === 0) {
        setError("ℹ️ No contacts found.");
        return;
      }

      const formatted = data.connections.map((person) => ({
        name: person.names?.[0]?.displayName || "No Name",
        email: person.emailAddresses?.[0]?.value || "No Email",
        phones:
          person.phoneNumbers?.map((p) => p.value).filter(Boolean) || [
            "No Phone",
          ],
      }));

      setContacts(formatted);
    } catch (err) {
      console.error(err);
      setError("❌ Failed to fetch contacts.");
    }
  };

  return (
    <div style={{ padding: 20, fontFamily: "Arial" }}>
      <h2>👥 Google Contacts</h2>

      {error && <p style={{ color: "red" }}>{error}</p>}

      {contacts.length > 0 ? (
        <>
          <h3>Total Contacts: {contacts.length}</h3>
          <ul>
            {contacts.map((c, i) => (
              <li key={i} style={{ marginBottom: 10 }}>
                <strong>{c.name}</strong> <br />
                📧 {c.email} <br />
                📱 {c.phones.join(", ")}
                <hr />
              </li>
            ))}
          </ul>
        </>
      ) : accessToken && !error ? (
        <p>⏳ Fetching contacts...</p>
      ) : (
        <p>📡 Initializing...</p>
      )}
    </div>
  );
};

export default GoogleContact;
